__turbopack_context__.v({
  "className": "jOBELG_className",
  "variable": "jOBELG_variable",
});
